import { useQuery } from '@tanstack/react-query';
import { UserRole, type Dashboard } from '@provenance/shared';
import { api } from '../lib/api';
import { useSession } from '../lib/session';

/**
 * The counts shown as badges on the navigation rail.
 *
 * Shares the dashboard endpoint and its React Query cache key, so opening the dashboard
 * does not fetch the same numbers a second time. Refetched on an interval because a
 * queue badge that is ten minutes stale is worse than no badge — an operator would stop
 * trusting it.
 */
export function useCounts() {
  const { user } = useSession();
  const isChamberUser =
    user?.role === UserRole.CHAMBER_ADMIN || user?.role === UserRole.CHAMBER_OPERATOR;

  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => api.get<Dashboard>('/api/console/documents/dashboard'),
    enabled: isChamberUser,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });
}
